import React from 'react';
import { Link } from 'react-router-dom';
import { Home, Search, ArrowLeft } from 'lucide-react';

const NotFoundPage: React.FC = () => {
  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-50 to-white flex items-center justify-center px-4">
      <div className="max-w-2xl w-full text-center">
        {/* Número 404 grande */}
        <div className="mb-8">
          <h1 className="text-[150px] md:text-[200px] font-bold text-[#B4897F] opacity-20 leading-none">
            404
          </h1>
        </div>

        {/* Icono y mensaje principal */}
        <div className="mb-8">
          <div className="inline-flex items-center justify-center w-24 h-24 bg-[#B4897F] bg-opacity-10 rounded-full mb-6">
            <Search className="w-12 h-12 text-[#B4897F]" />
          </div>
          
          <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-4">
            ¡Ups! Esta página no existe
          </h2>
          
          <p className="text-lg text-gray-600 mb-2">
            Lo sentimos, no pudimos encontrar la página que buscas.
          </p>
          <p className="text-gray-500">
            Es posible que la URL esté mal escrita o que la página haya sido movida.
          </p>
        </div>

        {/* Botones de acción */}
        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
          <Link
            to="/"
            className="inline-flex items-center gap-2 px-6 py-3 bg-[#B4897F] text-white rounded-lg hover:bg-[#A67A6F] transition-colors duration-300 shadow-md hover:shadow-lg"
          >
            <Home className="w-5 h-5" />
            <span>Volver al inicio</span>
          </Link>
          
          <button
            onClick={() => window.history.back()}
            className="inline-flex items-center gap-2 px-6 py-3 bg-white text-[#B4897F] border-2 border-[#B4897F] rounded-lg hover:bg-[#B4897F] hover:text-white transition-all duration-300"
          >
            <ArrowLeft className="w-5 h-5" />
            <span>Página anterior</span>
          </button>
        </div>

        {/* Links de ayuda */}
        <div className="mt-12 pt-8 border-t border-gray-200">
          <p className="text-gray-600 mb-4">¿Necesitas ayuda? Prueba con:</p>
          <div className="flex flex-wrap justify-center gap-4 text-sm">
            <Link to="/products" className="text-[#B4897F] hover:underline">
              Productos
            </Link>
            <Link to="/scheduling" className="text-[#B4897F] hover:underline">
              Agendar cita
            </Link>
            <Link to="/cursos" className="text-[#B4897F] hover:underline">
              Cursos
            </Link>
            <Link to="/eventos" className="text-[#B4897F] hover:underline">
              Eventos
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotFoundPage;
